export default {
  name: 'modalAgreementOwner',
  data() {
    return {
      checkedAccept: false,
    }
  },
  props: {
    url: {
      default: null,
      type: String,
    },
  },
  watch: {
    url: {
      handler: function(val) {
        // Set PDF file in viewer
        this.$refs.iframePdf.innerHTML =
          '<iframe id="iframePdf" height="400px" width="80%" allowfullscreen webkitallowfullscreen src="https://beta.greeneum.net/static/ViewerJS/index.html#' +
          val +
          '"></iframe>'
      },
      deep: true,
    },
  },
  methods: {
    accept() {
      this.$emit('accept')
      $('#modalAgreementOwner').modal('close')
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ModalAgreementOwner/ModalAgreementOwner.component.js